import Loader from "../../components/Loader";
import {useQuery} from "@tanstack/react-query";
import ProductGroup from "./ProductGroup";
import AddProductGroupButton from "./AddProductGroupButton";
import {useContext, useEffect, useState} from "react";
import Paginator from "../../components/Paginator";
import {
    Col,
    Form,
    FormFeedback,
    Row,
    Input,
    Label,
    Button,
    AccordionHeader,
    UncontrolledAccordion,
    AccordionItem, AccordionBody, Accordion
} from "reactstrap";
import AuthContext from "../../context/AuthContext";
import handleUnauthorized401QueryError from "../../utils/handleUnauthorized401QueryError";
import {getProductGroups} from "../../api/api";
import {toast} from "react-toastify";
import RecordsNotFound from "../../components/RecordsNotFound";


function ProductGroupPage() {
    const {refreshToken, user} = useContext(AuthContext)
    const [page, setPage] = useState(1);
    const [productGroupId, setProductGroupId] = useState("");
    const [productGroupName, setProductGroupName] = useState("");
    const [productGroupDescription, setProductGroupDescription] = useState("");
    const [productGroupPrice, setProductGroupPrice] = useState("");
    const [productGroupStatus, setProductGroupStatus] = useState("");
    const [productGroupCreatedDate, setProductGroupCreatedDate] = useState("");
    const [productGroupUpdatedDate, setProductGroupUpdatedDate] = useState("");
    const [productGroupTaxType, setProductGroupTaxType] = useState('');
    const [productGroupTaxPercentage, setProductGroupTaxPercentage] =useState("");

    const [queryKey, setQueryKey] = useState(['product-groups', page])
    const [openAdvancedSearch, setOpenAdvancedSearch] = useState(false);
    const [isAdvancedSearchDisabled, setIsAdvancedSearchDisabled] = useState(false);


    const toggleAdvancedSearch = () =>
        setOpenAdvancedSearch((prevState) => !prevState);

    useEffect(() => {
        setQueryKey(['product-groups', page])
    }, [page]);

    useEffect(() => {
        if(productGroupId === '' && productGroupName === ''&& productGroupDescription === '' &&
            productGroupPrice === '' && productGroupStatus === '' &&
            productGroupCreatedDate === '' && productGroupUpdatedDate === '' && productGroupTaxType === '' && productGroupTaxPercentage === ''){
            clearSearchProductGroup()
        }
    }, [productGroupId, productGroupName, productGroupDescription, productGroupPrice,
            productGroupStatus, productGroupCreatedDate, productGroupUpdatedDate, productGroupTaxType, productGroupTaxPercentage]);


    const { status, data, error, isFetching, refetch } = useQuery({
        queryKey: queryKey,
        queryFn: () => getProductGroups(page, productGroupId, productGroupName, productGroupDescription, productGroupPrice,
            productGroupStatus, productGroupCreatedDate, productGroupUpdatedDate, productGroupTaxType, productGroupTaxPercentage),
        keepPreviousData : true,
        retry: false,
        refetchOnWindowFocus: false,
        onError: (err => {
            handleUnauthorized401QueryError(err, refreshToken, refetch)
            if(err.response.status !== 401){
                toast.error(`An error occurred! ${err?.response?.data?.detail}`)
            }
        })
        })

    const shouldShowInitialLoader = status === 'loading' && !data;
    const shouldShowProductGroupTable = status === 'success' || Boolean(data) || error?.response?.status === 401;

    const searchProductGroup = (e) =>{
        e?.preventDefault()
        setPage(1)
        setQueryKey( ['product-groups', page, productGroupId, productGroupName, productGroupDescription, productGroupPrice,
            productGroupStatus, productGroupCreatedDate, productGroupUpdatedDate, productGroupTaxType, productGroupTaxPercentage])
    }

    const clearSearchProductGroup = (e) =>{
        e?.preventDefault()
        setProductGroupId('')
        setProductGroupName('')
        setProductGroupDescription('')
        setProductGroupPrice('')
        setProductGroupStatus('')
        setProductGroupCreatedDate('')
        setProductGroupUpdatedDate('')
        setProductGroupTaxType('')
        setProductGroupTaxPercentage('')
        setQueryKey( ['product-groups', 1])
        // setPage(1)
    }

    return (
        <>
        <UncontrolledAccordion defaultOpen="" flush={true}>
                <AccordionItem>
                    <AccordionHeader targetId="1">
                        <span><i className="mdi mdi-filter"/></span>
                    </AccordionHeader>
                    <AccordionBody accordionId="1">
                            <div className="card-box">
                                <div className="row">
                                    <div className="col-sm-12">

                                        <Form onSubmit={searchProductGroup}>
                                            <Row className="form-row align-items-center">
                                                <Col>
                                                    <Label
                                                        className="visually-hidden"
                                                        for="name"
                                                    >
                                                        Name
                                                    </Label>
                                                    <Input
                                                        id="product-group-name"
                                                        name="product-group-name"
                                                        type="text"
                                                        className="form-control mb-2"
                                                        onChange={(e) =>
                                                            setProductGroupName(
                                                                e.target.value
                                                            )
                                                        }
                                                        value={productGroupName}
                                                        invalid={
                                                            error && error.response.data.name
                                                        }
                                                    />
                                                    <FormFeedback invalid>
                                                        {error && error.response.data.name}
                                                    </FormFeedback>
                                                </Col>
                                                <Col>
                                                    <Label
                                                        className="visually-hidden"
                                                        for="price"
                                                    >
                                                        Price
                                                    </Label>
                                                    <Input
                                                        id="product-group-price"
                                                        name="product-group-price"
                                                        type="text"
                                                        className="form-control mb-2"
                                                        onChange={(e) =>
                                                            setProductGroupPrice(
                                                                e.target.value
                                                            )
                                                        }
                                                        value={productGroupPrice}
                                                        invalid={
                                                            error && error.response.data.price
                                                        }
                                                    />
                                                    <FormFeedback invalid>
                                                        {error && error.response.data.price}
                                                    </FormFeedback>
                                                </Col>
                                                <Col>
                                                <Label
                                                    className="visually-hidden"
                                                    for="price"
                                                >
                                                    Description
                                                </Label>
                                                <Input
                                                    id="description"
                                                    name="description"
                                                    type="text"
                                                    className="form-control mb-2"
                                                    onChange={(e) =>
                                                        setProductGroupDescription(
                                                            e.target.value
                                                        )
                                                    }
                                                    value={productGroupDescription}
                                                    invalid={
                                                        error && error.response.data.description
                                                    }
                                                />
                                                <FormFeedback invalid>
                                                    {error && error.response.data.description}
                                                </FormFeedback>
                                                </Col>
                                                <Col>
                                                    <Label
                                                        className="visually-hidden"
                                                        for="product-group-status"
                                                    >
                                                        Product Status
                                                    </Label>
                                                    <Input
                                                        type="select"
                                                        id="inputState"
                                                        className="form-control mb-2"
                                                        value={productGroupStatus}
                                                        onChange={(e) =>
                                                            setProductGroupStatus(
                                                                e.target.value
                                                            )
                                                        }
                                                    >
                                                        <option value="">--</option>
                                                        <option value={"ACTIVE"}>
                                                            Active
                                                        </option>
                                                        <option value={"INACTIVE"}>
                                                            Inactive
                                                        </option>
                                                    </Input>
                                                    {/*<FormFeedback invalid>*/}
                                                    {/*    {error && error.response.data.description}*/}
                                                    {/*</FormFeedback>*/}
                                                </Col>
                                                <Col>
                                                    <Label
                                                        className="visually-hidden"
                                                        for="product-group-date-created"
                                                    >
                                                        Date Created
                                                    </Label>
                                                    <Input
                                                        id="product-group-date-created"
                                                        name="product-group-date-created"
                                                        type="date"
                                                        className="form-control mb-2"
                                                        onChange={(e) =>
                                                            setProductGroupCreatedDate(
                                                                e.target.value
                                                            )
                                                        }
                                                        value={productGroupCreatedDate}
                                                        invalid={
                                                            error && error.response.data.created
                                                        }
                                                    />
                                                    <FormFeedback invalid>
                                                        {error && error.response.data.created}
                                                    </FormFeedback>
                                                </Col>

                                            </Row>
                                            {!isAdvancedSearchDisabled && (
                                                   <>
                                                      <Row className="form-row align-items-center">
                                                          <Col>
                                                              <div className="form-check">
                                                                  <Input
                                                                      type="checkbox"
                                                                      className="form-check-input"
                                                                      id="advanced-search"
                                                                      defaultChecked={openAdvancedSearch}
                                                                      disabled={isAdvancedSearchDisabled}
                                                                      onChange={() =>
                                                                          toggleAdvancedSearch()
                                                                      }
                                                                  />
                                                                  <Label
                                                                      check
                                                                      className="form-check-label mb-2"
                                                                      for="advanced-search"
                                                                  >
                                                                      Advanced Search
                                                                  </Label>
                                                              </div>
                                                          </Col>
                                                      </Row>
                                                      <Accordion open={openAdvancedSearch}>
                                                          <AccordionItem>
                                                              <AccordionBody accordionId={true}>
                                                                  <Row className="form-row align-items-center">
                                                                      <Col>
                                                                          <Label
                                                                              className="visually-hidden"
                                                                              for="product-group-id"
                                                                          >
                                                                              ID
                                                                          </Label>
                                                                          <Input
                                                                              id="product-group-id"
                                                                              name="product-group-id"
                                                                              type="text"
                                                                              className="form-control mb-2"
                                                                              onChange={(e) =>
                                                                                  setProductGroupId(
                                                                                      e.target.value
                                                                                  )
                                                                              }
                                                                              value={productGroupId}
                                                                              invalid={
                                                                                  error && error.response.data.id
                                                                              }
                                                                          />
                                                                          <FormFeedback invalid>
                                                                              {error && error.response.data.id}
                                                                          </FormFeedback>
                                                                      </Col>
                                                                      <Col>
                                                                          <Label
                                                                              className="visually-hidden"
                                                                              for="product-group-id"
                                                                          >
                                                                              Tax Type
                                                                          </Label>
                                                                          <Input
                                                                              type="select"
                                                                              id="inputState"
                                                                              className="form-control mb-2"
                                                                              value={productGroupTaxType}
                                                                              onChange={(e) =>
                                                                                  setProductGroupTaxType(
                                                                                      e.target.value
                                                                                  )
                                                                              }
                                                                          >
                                                                              <option value="">--</option>
                                                                              <option value={"TAX-INCLUSIVE"}>
                                                                                  Tax Inclusive
                                                                              </option>
                                                                              <option value={"TAX-EXCLUSIVE"}>
                                                                                  Tax Exclusive
                                                                              </option>
                                                                          </Input>
                                                                      </Col>
                                                                      <Col>
                                                                        <Label
                                                                            className="visually-hidden"
                                                                            for="date-updated"
                                                                        >
                                                                            Date Updated
                                                                        </Label>
                                                                        <Input
                                                                            id="date-updated"
                                                                            name="date-updated"
                                                                            type="date"
                                                                            className="form-control mb-2"
                                                                            onChange={(e) =>
                                                                                setProductGroupUpdatedDate(
                                                                                    e.target.value
                                                                                )
                                                                            }
                                                                            value={productGroupUpdatedDate}
                                                                            invalid={
                                                                                error && error.response.data.updated
                                                                            }
                                                                            />
                                                                        <FormFeedback invalid>
                                                                          {error && error.response.data.updated}
                                                                        </FormFeedback>
                                                                      </Col>
                                                                  </Row>
                                                              </AccordionBody>
                                                          </AccordionItem>
                                                      </Accordion>
                                                      </>
                                                   )}
                                            <Row className="form-row align-items-center">
                                              {isAdvancedSearchDisabled && (
                                                <Col>
                                                    <Button type="submit"
                                                            className="btn bx-btn-primary waves-effect waves-light mr-2"
                                                            disabled={!productGroupName && !productGroupPrice &&
                                                            !productGroupStatus && !productGroupDescription && !productGroupCreatedDate}
                                                    >
                                                        Search
                                                    </Button>

                                                    <Button type="button"
                                                            onClick={clearSearchProductGroup}
                                                            className="btn bx-btn-primary waves-effect waves-light"
                                                            disabled={!productGroupName && !productGroupPrice && !productGroupDescription &&
                                                            !productGroupStatus && !productGroupCreatedDate}
                                                    >
                                                        Clear
                                                    </Button>
                                                </Col>
                                              )}
                                              {!isAdvancedSearchDisabled && (
                                                 <Col>
                                                     <Button type="submit"
                                                             className="btn bx-btn-primary waves-effect waves-light mr-2"
                                                             disabled={!productGroupName && !productGroupPrice &&
                                                             !productGroupDescription && !productGroupStatus &&
                                                             !productGroupCreatedDate && !productGroupId && !productGroupTaxType &&
                                                             !productGroupUpdatedDate}
                                                     >
                                                         Search
                                                     </Button>

                                                     <Button type="button"
                                                             onClick={clearSearchProductGroup}
                                                             className="btn bx-btn-primary waves-effect waves-light"
                                                             disabled={!productGroupName && !productGroupPrice &&
                                                             !productGroupDescription && !productGroupStatus &&
                                                             !productGroupCreatedDate && !productGroupId && !productGroupTaxType &&
                                                             !productGroupUpdatedDate}
                                                     >
                                                         Clear
                                                     </Button>
                                                 </Col>
                                              )}
                                            </Row>
                                        </Form>
                                    </div>
                                </div>
                            </div>
                    </AccordionBody>
                </AccordionItem>
        </UncontrolledAccordion>

            <div className="row">
                <div className="col-12">

                    <div className="card-box">
                        <AddProductGroupButton/>
                        {shouldShowInitialLoader && (
                            <Loader size={'default'}/>
                        )}
                        {shouldShowProductGroupTable && (
                            <>
                                <div className="table-responsive">
                                    <table className="table table-centered mb-0">
                                        <thead className="font-13 bg-light text-muted">
                                        <tr>
                                            <th className="font-weight-medium">Image</th>
                                            <th className="font-weight-medium">Product Group Name</th>
                                            <th className="font-weight-medium">Price</th>
                                            <th className="font-weight-medium">Short Product Group URL</th>
                                            <th className="font-weight-medium">Included Products</th>
                                            <th className="font-weight-medium">Status</th>
                                            <th className="font-weight-medium">Created</th>
                                            <th className="font-weight-medium text-center">Action</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {data?.count > 0? data?.results?.map(productGroup => (
                                            <ProductGroup key={productGroup.id} productGroup={productGroup}/>
                                        )): <RecordsNotFound/>}
                                        </tbody>
                                    </table>
                                </div>
                                {status === 'success' && (
                                    <Paginator data={data} page={page} setPage={setPage} last={data?.last_page} loading={isFetching}/>
                                )}
                            </>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
}

export default ProductGroupPage;
